<div class="bottom-navbar-container text">
  <div class="bottom-navbar-item" *ngFor="let item of routeDatasC" [ngClass]="{ deactivate: activeItem !== item.id }" (click)="bottomMenuToogler(item.id)">
    <div class="bottom-navbar-item-icon">
      <!-- Şimdilik sadece b500 için kontrol koydum o yüzden böyle yazıldı,Sadece b500 de çalışacak -->
      <div [ngClass]="{ animation: (['b500'] | getProductName) === 'b500' }" class="count-badge" *ngIf="item.count > 0">
        {{ item.count }}
      </div>
      <image-loader-utils [url]="item.svgUrl" [extraClasses]="'svg bottom-navbar-icon ' + (item.svgUrl === 'casino' ? 'casino' : '')"></image-loader-utils>
    </div>

    <ng-container [ngSwitch]="['wettarena', 'b500'] | getProductName">
      <ng-container *ngSwitchCase="'wettarena'">
        <div class="bottom-navbar-item-text">{{ item.name | t }}</div>
      </ng-container>
      <ng-container *ngSwitchCase="'b500'">
        <ng-container *ngIf="item.id !== 15; else betslip">
          <div class="bottom-navbar-item-text">{{ item.name | t }}</div>
        </ng-container>
        <ng-template #betslip>
          <div
            class="bottom-navbar-item-text"
            *ngIf="
              this._DataHelper.currentSlipInfo.currentTotalRate === 0 ||
                this._DataHelper.currentSlipInfo.currentTotalRate === '0.00' ||
                this._DataHelper.currentSlipInfo.currentTotalRate === '1.00' ||
                this._DataHelper.currentSlipInfo.currentTotalRate === '0,00' ||
                this._DataHelper.currentSlipInfo.currentTotalRate === '1,00';
              else animation
            ">
            {{ item.name | t }}
          </div>
          <ng-template #animation>
            <div id="animationselector" [ngClass]="{ animation: this._DataHelper.isSelectOdd, animationNone: !this._DataHelper.isSelectOdd }" class="bottom-navbar-item-text">
              {{ this._DataHelper.currentSlipInfo.currentTotalRate }}
            </div>

            <div [ngClass]="{ 'animation-text': this._DataHelper.isSelectOdd }" class="bottom-navbar-item-text">{{ item.name | t }}</div>
          </ng-template>
        </ng-template>
      </ng-container>
      <ng-container *ngSwitchDefault>
        <div class="bottom-navbar-item-text">{{ item.name | t }}</div>
      </ng-container>
    </ng-container>
  </div>
</div>
